import { usePublishingContext } from "../../../contexts/PublishingContext.js";
import { echartsDarkTheme } from "../constants/echartsDarkTheme.js";
import React, { useEffect, useMemo } from "react";
import { useAtalayaContext } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
import * as echarts from "echarts/core";
import { LegendComponent, TitleComponent, TooltipComponent } from "echarts/components";
import { PieChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";
import { LabelLayout } from "echarts/features";
//#region src/modules/Stats/shared/ReportTypesPieChart.tsx
echarts.use([
	TitleComponent,
	TooltipComponent,
	LegendComponent,
	PieChart,
	CanvasRenderer,
	LabelLayout
]);
echarts.registerTheme("THERMS Dark", echartsDarkTheme);
function ReportTypesPieChart({ reportTypeCount }) {
	const { isDarkMode } = useAtalayaContext();
	const isPublishing = usePublishingContext()?.isPublishing;
	const total = useMemo(() => reportTypeCount.reduce((acc, eventType) => acc + eventType.count, 0), [reportTypeCount]);
	const containerRef = React.useRef(null);
	useEffect(() => {
		if (!containerRef.current) return void 0;
		const chart = echarts.init(containerRef.current, isDarkMode ? "THERMS Dark" : "light");
		const option = {
			series: [{
				data: reportTypeCount.map(({ count, reportType }) => ({
					name: reportType,
					value: count
				})),
				emphasis: { itemStyle: {
					shadowBlur: 10,
					shadowColor: "rgba(0, 0, 0, 0.5)",
					shadowOffsetX: 0
				} },
				itemStyle: { color: ({ dataIndex }) => reportTypeCount[dataIndex].color || "#000" },
				label: {
					formatter: " {d}% {b} ({c})",
					overflow: "break",
					show: true
				},
				name: "Report Types",
				radius: "60%",
				type: "pie"
			}],
			title: {
				left: "center",
				subtext: `${total} Total`,
				subtextStyle: { lineHeight: 4 },
				text: "Report Types Share"
			}
		};
		if (!isPublishing) option.tooltip = { trigger: "item" };
		chart.setOption(option);
		return () => chart.dispose();
	}, [
		reportTypeCount,
		containerRef.current,
		isDarkMode
	]);
	return /* @__PURE__ */ jsx("div", {
		className: "h-full w-full",
		ref: containerRef,
		style: { height: 500 }
	});
}
//#endregion
export { ReportTypesPieChart };

//# sourceMappingURL=ReportTypesPieChart.js.map